export enum DashboardType {
  BehaviorManagementOverview = 26,
  DistrictUsage = 27,
  ELearningImplementationOverview = 29,
  DashboardActivity = 28,
}
export enum DashboardLabel {
  BehaviorManagementOverview = 'Dashboard Behavior Management Overview Component',
  DistrictUsage = 'Dashboard District Usage Component',
}
export enum DashboardBehaviorManagementComponent {
  VolumeOfBehaviorCategories = 106,
  TeamMembersSupportingCasesTop10 = 107,
  CaseVolumeTop10 = 108,
  VolumeOfLoginsPerSchoolTop10 = 109,
  BehaviorScreener = 110,
  CaseActivity = 111,
  AgeRange = 112,
  CasesByRace = 113,
  CasesByGeneralEducation = 114,
  CasesBySpecialEducation = 115,
  Top10ImplementedStrategies = 116,
  FunctionsByBehavior = 117,
  CaseData = 118,
}

export const BehvaiorManagmentLable = {
  VolumeOfBehaviorCategories: [
    'BehaviorCategory',
    'Count',
    'percentage(%)',
  ] as const,
  TeamMembersSupportingCasesTop10: [
    'Organization Name',
    'TeamMember (Count Distinct)',
    'percentage(%)',
  ] as const,
  CaseVolumeTop10: [
    'Organization Name',
    'Case Volume',
    'percentage(%)',
  ] as const,
  VolumeOfLoginsPerSchoolTop10: [
    'Organization Name',
    'Logins (Count Distinct)',
    'percentage(%)',
  ] as const,
  BehaviorScreener: ['BehaviorScreener', 'Count', 'percentage(%)'] as const,
  CaseActivity: ['CaseActivity', 'Count', 'percentage(%)'] as const,
  AgeRange: ['AgeRange', 'Count', 'percentage(%)'] as const,
  CasesByRace: ['Race', 'Count', 'percentage(%)'] as const,
  CasesByGeneralEducation: [
    'General Education',
    'Count',
    'percentage(%)',
  ] as const,
  CasesBySpecialEducation: [
    'Special Education',
    'Count',
    'percentage(%)',
  ] as const,
  Top10ImplementedStrategies: ['Strategy', 'Count', 'percentage(%)'] as const,
  FunctionsByBehavior: ['Function', 'Count', 'percentage(%)'] as const,
  CaseData: ['CaseData', 'Count', 'percentage(%)'] as const,
};

export enum DashboardDistrictUsageComponent {
  VolumeOfBehaviorsByOrganizationTop7 = 119,
  HoursOfPDByOrganizationTop7 = 120,
  DataCollectionByOrganizationTop7 = 121,
  OrganizationsWithTopEnrollmentTop7 = 122,
  DistrictUsageSummaryTable = 123,
}

export const DistrictUsageLabel = {
  VolumeOfBehaviorsByOrganizationTop7: [
    'Organization Name',
    'Behavior Count',
    'percentage(%)',
  ] as const,
  HoursOfPDByOrganizationTop7: [
    'Organization Name',
    'Hours of PD',
    'percentage(%)',
  ] as const,
  DataCollectionByOrganizationTop7: [
    'Organization Name',
    'Data Collection Count',
    'percentage(%)',
  ] as const,
  OrganizationsWithTopEnrollmentTop7: [
    'Organization Name',
    'Enrollment Count',
    'percentage(%)',
  ] as const,
};

export enum DashboardElearningComponent {
  HoursOfPDByOrganizationTop7 = 139,
  WorkshopsWithExpiredDeadlinesTop7Organizations = 140,
  CompletedWorkshops = 141,
}

export const ELearningLabel = {
  HoursOfPDByOrganizationTop7: [
    'Organization Name',
    'Hours of PD',
    'percentage(%)',
  ] as const,
  WorkshopsWithExpiredDeadlinesTop7Organizations: [
    'Organization Name',
    'Workshops with Expired Deadlines',
    'percentage(%)',
  ] as const,
  CompletedWorkshops: ['Workshop Name', 'Count', 'percentage(%)'] as const,
};

export enum LmsChartType {
  'hours_summary' = 120,
  'top_ennrolled' = 122,
}

export enum ELearningChartType {
  HoursSummary = 'hours_summary',
  DeadlineSummary = 'dedline_summary',
  Completed = 'total_workshop_details',
}

export enum DashboardActivityComponent {
  LoginActivity = 125,
  TotalLoginActivity = 126,
  DataCollectionActivity = 127,
  TotalDataPointsByTypeEntered = 128,
  WorkshopActivity = 129,
  TopDistinctLoginsByDistrict = 130,
  TopNonDistinctLoginsByDistrict = 131,
  TopBehaviorCasesByType = 132,
  TotalCollectedPoints = 133,
  TopWorkshopsCompleted = 134,
  TopWorkshopsAccessed = 135,
  TopQuizzesPassed = 136,
  TopQuizzesAccessed = 137,
  TotalWorkshopsQuizzesCompleted = 138,
}

export const DashboardActivityLabel = {
  LoginActivity: [
    'Date',
    'Login Activity Count',
    'Non Login Activity Count',
  ] as const,
  TotalLoginActivity: ['Total Login Activity', 'Count'] as const,
  DataCollectionActivity: [
    'Date',
    'Duration Data Recorded by Interval',
    'Frequency Recorded by Day',
    'Frequency Recorded by Interval',
  ] as const,
  TotalDataPointsByTypeEntered: ['Data Type', 'Count'] as const,
  WorkshopActivity: [
    'Date',
    'Accessed but not completed Count',
    'Completed Workshop Count',
  ] as const,
  TopDistinctLoginsByDistrict: [
    'District Name',
    'Distinct Logins',
    'percentage(%)',
  ] as const,
  TopNonDistinctLoginsByDistrict: [
    'District Name',
    'Non-Distinct Logins',
    'percentage(%)',
  ] as const,
  TopBehaviorCasesByType: ['Behavior Type', 'Count', 'percentage(%)'] as const,
  TotalCollectedPoints: ['Orgnization', 'Count', 'percentage(%)'] as const,
  TopWorkshopsCompleted: ['Workshop Name', 'Count', 'percentage(%)'] as const,
  TopWorkshopsAccessed: ['Workshop Name', 'Count', 'percentage(%)'] as const,
  TopQuizzesPassed: ['Quiz Name', 'Count', 'percentage(%)'] as const,
  TopQuizzesAccessed: ['Quiz Name', 'Count', 'percentage(%)'] as const,
  TotalWorkshopsQuizzesCompleted: ['Workshop Name', 'Count'] as const,
};

export enum DashboardActivityChartType {
  'WorkshopActivity' = 129,
  'completed' = 134,
  'accessed' = 135,
  'QuizPassed' = 136,
  'QuizAccessed' = 137,
  'TotalWorkshops' = 138,
}

export enum UserRole {
  LocalSystemAdmin = 'Local System Admin',
  DistricSettingsAdmin = 'District Settings Admin',
  SystemAdmin = 'System Admin',
  CMSOwner = 'CMS Owner',
  CMSManager = 'CMS Manager',
  CMSDataEntry = 'CMS Data Entry',
  CMSBrowser = 'CMS Browser',
  FidelityChecker = 'Fidelity Checker',
}
